import { useAtomValue } from 'jotai'
import { noAudioAtom } from '@renderer/hooks/audio/no-audio-state'

export function useNoAudio(): boolean {
  return useAtomValue(noAudioAtom)
}
